const setCourses = (state, payload) => {
    state.courses = payload;
};
const setCoursesHome = (state, payload) => {
    state.courses_home = payload;
};
const setCourse = (state, payload) => {
    if (payload) {
        payload.material.map(e => {
            e.open = false
            e.lessons_count = e.lessons.length
        })
    }
    state.course = payload;
};
const pushCourse = (state, payload) => {
    state.courses.page = payload.page
    payload.result.map(e => state.courses.result.push(e))
};
const pushCertificatedCourses = (state, payload) => {
    state.certificatedCourses.page = payload.page
    payload.result.map(e => state.certificatedCourses.result.push(e))
};
const setReviews = (state, payload) => {
    state.reviews = payload;
};
const pushReviews = (state, payload) => {
    if (payload) {
        state.reviews.page = payload.page;
        payload.result.map(e => {
            state.reviews.result.push(e)
        })
    }
};
const postReviews = (state, payload) => {
    if (payload) state.reviews.result.unshift(payload.data)
};
const setLesson = (state, payload) => {
    if (payload){
        state.lesson = payload
    }
};
const setCertificatedCourses = (state, payload) => {
    state.certificatedCourses = payload
};
const setQuiz = (state, payload) => {
    state.quiz = payload
};
const setQuizInfo = (state, payload) => {
    state.quizInfo = payload
};
const setQuizHeader = (state, payload) => {
    state.quizHeader = payload
};
const setSubmitQuiz = (state, payload) => {
    state.submitQuiz = payload
};

export default {
    setCourses,
    setCoursesHome,
    setCourse,
    setReviews,
    pushReviews,
    pushCourse,
    pushCertificatedCourses,
    setLesson,
    setCertificatedCourses,
    setQuiz,
    setSubmitQuiz,
    setQuizHeader,
    setQuizInfo,
    postReviews
};